import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";

const TakeawayModal = ({ order, onClose, updateOrderStatus,
  getCatalogOrder,   
  userID     }) => {

  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
  try {
    setLoading(true);

    const payload = {
      userid: userID,
      orderid: order.orderid,
      productid: "",
      status: "ready_for_takeaway",
      time: "",
      payment: "",
    };

    const res = await updateOrderStatus(payload);

    if (res?.responseCode === "00") {
      toast.success("Ready for takeaway");

      await getCatalogOrder();

      window.dispatchEvent(new Event("orderUpdated"));

      onClose();
    } else {
      toast.error(res?.responseMessage || "Failed");
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  } finally {
    setLoading(false);
  }
};

  if (!order) return null;

  return (
    <>
   <ToastContainer/>
    <div className="fixed inset-0 bg-black/40 flex items-center montserrat-font-1 justify-center z-[9999]">
      <div className="bg-white w-[420px] rounded-xl shadow-lg overflow-hidden">
        
        {/* Header */}
        <div className="flex justify-between montserrat-font-1 items-center px-5 py-3 border-b">
          <h2 className="text-lg font-semibold">Takeaway</h2>
          <button onClick={onClose} className="text-gray-500 text-xl">×</button>
        </div>

        {/* Body */}
        <div className="px-5 py-4">
          <h3 className="font-semibold text-gray-800">
            Takeaway Order
          </h3>
          <p className="text-gray-600 mt-1 montserrat-font-1">
            Please prepare the order for pickup.
          </p>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-5 py-3 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-md"
          >
            Close
          </button>

          <button
            onClick={handleConfirm}
            disabled={loading}
            className="px-4 py-2 bg-blue-500 text-white rounded-md disabled:opacity-50"
          >
            {loading ? "Processing..." : "Ready For Takeaway"}
          </button>
        </div>

      </div>
    </div>
    </>
  );
};

export default TakeawayModal;